import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import './index.css';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import "react-datepicker/dist/react-datepicker.css";
// import "leaflet/dist/leaflet.css" 

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
         <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Router>
      <App />
    </Router>
    
    </ThemeProvider> 
      </PersistGate>
       
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
